import { createUseStyles } from 'react-jss';

import { SnackbarType } from '../../../hooks/snackbar/types';

const colorFn = ({ type }) => (type === SnackbarType.WARNING ? '#000' : '#fff');

export default createUseStyles<string, { type: SnackbarType }>(
  {
    root: {
      backgroundColor: ({ type }) =>
        type === SnackbarType.WARNING ? 'var(--x-status-warning)' : 'var(--x-bg-10)',
      borderRadius: 12,
      color: colorFn,
      display: 'flex',
      fontSize: 16,
      fontWeight: 600,
      justifyContent: 'space-between',
      lineHeight: '24px',
      padding: [12, 16],
    },
    container: {
      display: 'flex',
      flex: 1,
    },
    child: {
      flex: 1,
    },
    icon: {
      marginRight: 24,
      marginTop: 2,

      '& path': {
        fill: colorFn,
      },
    },

    close: {
      cursor: 'pointer',
      fill: colorFn,
      marginLeft: 24,
    },
  },
  { name: 'Sanckbar' },
);
